import React from 'react';
import { PRIORITY_OPTIONS, PRIORITY_LIST } from '../constants/priority';
import './PriorityBadge.css';

/**
 * 優先度バッジ（閲覧モード用）
 *
 * @param {number|null} priority - 優先度値 (1〜4, null=未設定)
 */
export function PriorityBadge({ priority }) {
    const opt = PRIORITY_OPTIONS[priority];
    if (!opt) {
        return <span className="priority-badge-empty">未設定</span>;
    }
    return (
        <span
            className="priority-badge"
            style={{
                backgroundColor: opt.bg,
                color: opt.color,
                borderColor: opt.border,
            }}
        >
            {opt.label}{opt.text}
        </span>
    );
}

/**
 * 優先度バッジ（一覧テーブル用・コンパクト版）
 *
 * @param {number|null} priority - 優先度値 (1〜4, null=未設定)
 */
export function PriorityBadgeCompact({ priority }) {
    const opt = PRIORITY_OPTIONS[priority];
    if (!opt) {
        return <span className="priority-badge-empty">—</span>;
    }
    return (
        <span
            className="priority-badge priority-badge--compact"
            style={{
                backgroundColor: opt.bg,
                color: opt.color,
            }}
        >
            {opt.label}{opt.text}
        </span>
    );
}

/**
 * 優先度トグル（編集モード用）
 *
 * 同じボタンを再クリックすると null (未設定) に戻る。
 *
 * @param {number|null} value    - 現在の優先度
 * @param {function}    onChange - (newValue: number|null) => void
 */
export function PriorityToggle({ value, onChange }) {
    return (
        <div className="priority-toggle">
            {PRIORITY_LIST.map(opt => {
                const isActive = value === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        className={`priority-toggle__btn ${isActive ? 'priority-toggle__btn--active' : ''}`}
                        style={isActive ? {
                            backgroundColor: opt.bg,
                            color: opt.color,
                            boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                        } : undefined}
                        onClick={() => onChange(isActive ? null : opt.value)}
                    >
                        <span className="priority-toggle__symbol">{opt.label}</span>
                        <span>{opt.text}</span>
                    </button>
                );
            })}
        </div>
    );
}
